import React from "react";
import { Button } from "antd";
import { STATUSES } from "../../config/constants/defaultValues";

const SaveButton = ({ title, loading }) => {
  return (
    <>
      <Button
        type="button"
        style={{ fontWeight: "500 !important" }}
        className="approved_btn"
        htmlType="submit"
        loading={loading===STATUSES.LOADING?true:false }
      >
        {title}
      </Button>
    </>
  );
};

export default SaveButton;
